import { complement, compose, fromPairs, filter, isNil, map, prop, toPairs, reverse, propOr } from 'ramda';

const SLUGGABLE_ENTITIES = ['experiences', 'kioskModes', 'markets'];

const flipObject = compose(
  fromPairs,
  map(reverse),
  toPairs
);

const generateSlugsFor = compose(
  flipObject,
  filter(complement(isNil)),
  map(prop('slug'))
);

export const generateSlugsRegistry = content =>
  compose(
    fromPairs,
    map(entity => [entity, generateSlugsFor(propOr({}, entity, content))])
  )(SLUGGABLE_ENTITIES);
